module.exports = __webpack_public_path__ + "img/home_49.a9bf04ad.svg";